import { OverallSurveyApi } from 'api/OverallSurveyApi';
import { apiClient } from 'container/apiClient';
import { overallSurveyMapper } from 'container/overallSurveyMapper';

export const overallSurveyApi = new OverallSurveyApi(apiClient, overallSurveyMapper);
